<template>
    <b-collapse class="shortContent" id="collapse_short" >
        <CloseButton v-b-toggle.collapse_short></CloseButton>
        <b-container class="pb-5">
            <h3 v-b-tooltip.hover.bottom="'Only essential information!'" class="pt-5 pb-3">Resume</h3>
            <b-row>
                <b-col md="4" sm="6" xs="12">
                    <section class="content">
                        <span class="title"><font-awesome-icon class="icon" icon="comment-alt"></font-awesome-icon><strong>About</strong> me</span>
                        <p class="mt-3">
                            Front-end developer looking for new challenges and opportunities to learn and improve my skills.
                        </p>
                        <p>
                            I aim to become part of a company where my skills and knowledge are valued and always
                            improving; where my contribution to its growth is recognized and appreciated; a place
                            where my work has meaning.
                        </p>
                        <p>
                            I decided to learn programming and it was the best decision I ever made.
                            Love the satisfaction of bringing code to life in amazing designs.
                        </p>
                    </section>
                    <section class="content pt-5">
                        <span class="title"><font-awesome-icon class="icon" icon="language"></font-awesome-icon><strong>Language</strong> skills</span>
                        <div class="skill_type">
                            <h6 class="mt-3">Romanian</h6>
                            <b-progress :max="max">
                                <b-progress-bar :value="max" :label="`${max}%`"></b-progress-bar>
                            </b-progress>
                        </div>
                        <div class="skill_type">
                            <h6 class="mt-3">English</h6>
                            <b-progress :max="max">
                                <b-progress-bar :value="90" :label="`90%`"></b-progress-bar>
                            </b-progress>
                        </div>
                        <div class="skill_type">
                            <h6 class="mt-3">Japanese</h6>
                            <b-progress :max="max">
                                <b-progress-bar :value="40" :label="`40%`"></b-progress-bar>
                            </b-progress>
                        </div>
                    </section>
                </b-col>

                <b-col md="4" sm="6" xs="12">
                    <section class="content">
                        <span class="title"><font-awesome-icon class="icon" icon="university"></font-awesome-icon><strong>Experience</strong></span>
                        <div class="short-timeline mt-3">
                            <article class="timeline-event">
                                <div class="event-date pb-2">Sept-Oct 2019</div>
                                <div class="event-name ">Learner</div>
                                <div class="event-description ">Coder's Lab</div>
                            </article>
                            <article class="timeline-event">
                                <div class="event-date pb-2">2016-2017</div>
                                <div class="event-name ">Copywriter</div>
                                <div class="event-description ">Digital Web Properties</div>
                            </article>
                            <article class="timeline-event">
                                <div class="event-date pb-2">2013-2015</div>
                                <div class="event-name">Master's: International Relations</div>
                                <div class="event-description ">UB, Faculty of Philosophy</div>
                            </article>
                        </div>
                        <section class="content mt-5">
                            <span class="title"><font-awesome-icon class="icon" icon="cogs"></font-awesome-icon><strong>Secondary</strong> skills</span>
                            <h6 class="mt-3">General skills:</h6>
                            <div class="firstLine mt-1">
                                <span>Critical thinking</span>
                                <span>Adobe Photoshop</span>
                                <span>Microsoft Office</span>
                                <span>Research</span>
                                <span>Creative Writing</span>
                            </div>
                            <h6 class="mt-3">Front-end skills:</h6>
                            <div class="secondLine">
                                <span>jQuery</span>
                                <span>RWD</span>
                                <span>Ajax</span>
                                <span>Git</span>
                                <span>Webpack</span>
                                <span>SEO</span>
                                <span>REST API</span>
                            </div>
                        </section>
                    </section>
                </b-col>
                <b-col md="4" sm="6" xs="12">
                    <section class="content">
                        <span class="title">
                            <font-awesome-icon class="icon" icon="laptop-code"></font-awesome-icon>
                            <strong>Main</strong>
                            skills
                        </span>
                        <div class="skill_type">
                            <h6 class="mt-3">HTML5/CSS3/Bootstrap 4/SASS</h6>
                            <b-progress :max="max">
                                <b-progress-bar :value="80" :label="`80%`"></b-progress-bar>
                            </b-progress>
                        </div>
                        <div class="skill_type">
                            <h6 class="mt-3">Javascript</h6>
                            <b-progress :max="max">
                                <b-progress-bar :value="70" :label="`70%`"></b-progress-bar>
                            </b-progress>
                        </div>
                        <div class="skill_type">
                            <h6 class="mt-3">React</h6>
                            <b-progress :max="max">
                                <b-progress-bar :value="65" :label="`65%`"></b-progress-bar>
                            </b-progress>
                        </div>
                        <div class="skill_type">
                            <h6 class="mt-3">Vue</h6>
                            <b-progress :max="max">
                                <b-progress-bar :value="30" :label="`30%`"></b-progress-bar>
                            </b-progress>
                        </div>
                    </section>
                    <section class="content mt-5">
                        <span class="title">
                            <font-awesome-icon class="icon" icon="info-circle"></font-awesome-icon>
                            <strong>Other</strong>
                            info
                        </span>
                        <div class="firstLine mt-3">
                            <h6>Portfolio:</h6>
                            <a href="https://emilsprojects.site">emilsprojects.site</a>
                        </div>
                        <div class="secondLine mt-3">
                            <h6>Certifications:</h6>
                            <a href="https://www.cambridgeenglish.org/exams-and-tests/advanced/">C1 English</a>
                            <a href="https://www.coderslab.ro/cursuri/front-end/javascript-react/">Coder's Lab</a>
                        </div>
                        <div class="thirdLine mt-3">
                            <h6 class="mb-4">Hobbies & interests:</h6>
                            <span><font-awesome-icon class="hobby-icon" icon="gamepad"></font-awesome-icon></span>
                            <span><font-awesome-icon class="hobby-icon" icon="book-open"></font-awesome-icon></span>
                            <span><font-awesome-icon class="hobby-icon" icon="dumbbell"></font-awesome-icon></span>
                        </div>
                    </section>
                </b-col>
            </b-row>
        </b-container>
    </b-collapse>
</template>
<script>
    import CloseButton from "./CloseButton";
    export default {
        name: "ShortContent",
        components: {CloseButton},
        data() {
            return {
                max: 100
            }
        }
    }
</script>

<style scoped>
     .shortContent {
         background: linear-gradient(to top, #0060B0, #00B4DB);
         height: auto;
     }
     .row {
         margin: 0;
     }

     h3 {
         color: white;
         text-shadow: 0 0 8px blue;
         width: 15%;
     }
     h3:hover {
         text-shadow: 0 0 8px yellow;
     }
    .title {
        font-size: 18px;
        color: black;
        text-shadow: 0 0 2px blue;
    }
    .icon {
        color: white;
        font-size: 25px;
    }
    p {
        text-indent: 30px;
        font-size: 14px;
        color: navy;
        text-shadow: 2px 2px 3px gray;
    }
    p:nth-of-type(2) {
        color: white;
        text-shadow: 2px 2px 3px blue;
    }
    .short-timeline {
        border-left: 1px solid rgba(255, 255, 255, 0.4);
        padding-top: 20px;
    }
    .timeline-event {
        padding: 0 0 30px 30px;
        position: relative;
    }
    .timeline-event::after{
        position: absolute;
        content: "";
        top: -2px;
        left: -10px;
        width: 20px;
        height: 20px;
        background: navy;
        border-radius: 50%;
        border: 6px solid #00B4DB;
    }
    .event-description {
        font-size: 14px;
        color: white;
    }
    .event-name {
        font-weight: bold;
        color: navy;
    }
    .event-date {
        font-size: 12px;
    }
    h6 {
        color: navy;
        font-weight: bold;
        font-size: 17px;
    }

    .firstLine > span, .secondLine >span {
        padding: 0 5px;
        margin: 5px;
        border-radius: 5px;
        background: blue;
        color: white;
        font-size: 12px;
        height: auto;
        display: inline-block;
        line-height: 25px;
    }
    .firstLine > a, .secondLine > a {
        margin-left: 10px;
        color: white;
        text-shadow: 0 0 8px blue;

    }
    .thirdLine >span {
        position: relative;
        margin-right: 20px;
        z-index: 2;
    }
     .thirdLine > span::after {
        position: absolute;
        content: "";
        top: -16px;
        left: -10px;
        height: 50px;
        width: 50px;
        background: rgba(255, 255, 255, 1);
        border-radius: 50%;
        z-index: -1;
     }
    .hobby-icon {
        color: navy;
        font-size: 25px;
        margin-right: 20px;
    }
</style>